import cities from '../../assets/data/cities.json';
import schools from '../../assets/data/schools.json';
import countries from '../../assets/data/countries.json';
import districts from '../../assets/data/districts.json';
import subdistricts from '../../assets/data/subdistricts.json';
import { ICity } from '../views/pages/lectures/cities/city.interface';
import { ISchool } from '../views/pages/lectures/schools/school.interface';
import { ICountry, IDistrict } from '../views/pages/lectures/cities/country.interface';

export enum GeneralEnum {
    EVERYTHING = 'everything'
}

export enum LocaleEnum {
    HE = 'he',
    EN = 'en'
}

export enum AgeGroupEnum {
    PREK = 'PREK',
    ELEMENTARY = 'ELEMENTARY',
    MIDDLESCHOOL = 'MIDDLESCHOOL',
    HIGHSCHOOL = 'HIGHSCHOOL',
    ADULTS = 'ADULTS'
}

export enum AdultsInstituteTypeEnum {
    ARMY = 'ARMY',
    COMPANY = 'COMPANY',
    ORGANIZATION = 'ORGANIZATION',
    HIGH_ED = 'HIGH_ED',
    OTHER = 'OTHER'
}

export enum LectureStatusEnum {
    PENDING = 'PENDING',
    UNASSIGNED = 'UNASSIGNED',
    ASSIGNED = 'ASSIGNED',
    SCHEDULED = 'SCHEDULED',
    COMPLETE = 'COMPLETE',
    IRRELEVANT = 'IRRELEVANT'
}

export enum LanguagesEnum {
    ARABIC = 'ARABIC',
    HEBREW = 'HEBREW',
    ENGLISH = 'ENGLISH',
    RUSSIAN = 'RUSSIAN',
    SPANISH = 'SPANISH',
    PORTUGUESE = 'PORTUGUESE',
    FRENCH = 'FRENCH',
    OTHER = 'OTHER'
}

export enum WeekdaysEnum {
    SUNDAY = 'SUNDAY',
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
}

export enum LectureOnlineTypeEnum {
    ONLINE = 'ONLINE',
    FRONTAL = 'FRONTAL'
}

export enum LectureTypeEnum {
    PAID = 'PAID',
    NONPAID = 'NONPAID'
}

export enum LecturePriorityEnum {
    HIGH = 'HIGH',
    NORMAL = 'NORMAL'
}

export class LectureValuesData {
    public static ageGroups: any[] = [
        {id: AgeGroupEnum.PREK, nameEN: 'Preschool', nameHE: 'גן', skyz: 'גן'},
        {id: AgeGroupEnum.ELEMENTARY, nameEN: 'Elementary', nameHE: 'יסודי', skyz: 'יסודי'},
        {id: AgeGroupEnum.MIDDLESCHOOL, nameEN: 'Middle School', nameHE: 'חטיבת ביניים', skyz: 'חטיבה'},
        {id: AgeGroupEnum.HIGHSCHOOL, nameEN: 'High School', nameHE: 'תיכון', skyz: 'תיכון'},
        {id: AgeGroupEnum.ADULTS, nameEN: 'Adults', nameHE: 'בוגרים', skyz: 'בוגרים'}
    ];

    public static adultsInstituteTypes: any[] = [
        {id: AdultsInstituteTypeEnum.ARMY, nameEN: 'Army', nameHE: 'צבא', skyz: 'צבא'},
        {id: AdultsInstituteTypeEnum.COMPANY, nameEN: 'Company', nameHE: 'חברה', skyz: 'חברה'},
        {id: AdultsInstituteTypeEnum.ORGANIZATION, nameEN: 'Organization', nameHE: 'עמותה', skyz: 'עמותה'},
        {id: AdultsInstituteTypeEnum.HIGH_ED, nameEN: 'High Education', nameHE: 'השכלה גבוהה',  skyz: 'השכלה גבוהה'},
        {id: AdultsInstituteTypeEnum.OTHER, nameEN: 'Other', nameHE: 'אחר', skyz: 'אחר'},
    ];

    public static cities: ICity[] = cities;
    public static schools: ISchool[] = schools;
    public static countries: ICountry[] = countries;
    public static districts: IDistrict[] = districts;
    public static subdistricts: IDistrict[] = subdistricts;

    public static languages: any[] = [
        {id: LanguagesEnum.HEBREW, nameEN: 'Hebrew', nameHE: 'עברית', latinLettersEN: 'HE'},
        {id: LanguagesEnum.ARABIC, nameEN: 'Arabic', nameHE: 'ערבית' , latinLettersEN: 'AR'},
        {id: LanguagesEnum.ENGLISH, nameEN: 'English', nameHE: 'אנגלית' , latinLettersEN: 'EN'},
        {id: LanguagesEnum.RUSSIAN, nameEN: 'Russian', nameHE: 'רוסית' , latinLettersEN: 'RU'},
        {id: LanguagesEnum.SPANISH, nameEN: 'Spanish', nameHE: 'ספרדית' , latinLettersEN: 'ES'},
        {id: LanguagesEnum.PORTUGUESE, nameEN: 'Portuguese', nameHE: 'פורטוגזית' , latinLettersEN: 'PT'},
        {id: LanguagesEnum.FRENCH, nameEN: 'French', nameHE: 'צרפתית' , latinLettersEN: 'FR'},
        {id: LanguagesEnum.OTHER, nameEN: 'Other', nameHE: 'אחר' , latinLettersEN: 'Other'}
    ];

    public static weekdays: any[] = [
        {id: WeekdaysEnum.SUNDAY, nameEN: 'Sunday', nameHE: 'ראשון', abbrEN: 'Sun', abbrHE: 'א׳'},
        {id: WeekdaysEnum.MONDAY, nameEN: 'Monday', nameHE: 'שני', abbrEN: 'Mon', abbrHE: 'ב׳'},
        {id: WeekdaysEnum.TUESDAY, nameEN: 'Tuesday', nameHE: 'שלישי', abbrEN: 'Tue', abbrHE: 'ג׳'},
        {id: WeekdaysEnum.WEDNESDAY, nameEN: 'Wednesday', nameHE: 'רביעי', abbrEN: 'Wed', abbrHE: 'ד׳'},
        {id: WeekdaysEnum.THURSDAY, nameEN: 'Thursday', nameHE: 'חמישי', abbrEN: 'Thu', abbrHE: 'ה׳'},
        {id: WeekdaysEnum.FRIDAY, nameEN: 'Friday', nameHE: 'שישי', abbrEN: 'Fri', abbrHE: 'ו׳'},
        {id: WeekdaysEnum.SATURDAY, nameEN: 'Saturday', nameHE: 'שבת', abbrEN: 'Sat', abbrHE: 'ש׳'},
    ];

    public static types: any[] = [
        {id: LectureOnlineTypeEnum.ONLINE, nameEN: 'Online', nameHE: 'מקוונת'},
        {id: LectureOnlineTypeEnum.FRONTAL, nameEN: 'Frontal', nameHE: 'פרונטלית'}
    ];

    public static priorities: any[] = [
        {id: LecturePriorityEnum.HIGH, nameEN: 'High', nameHE: 'גבוהה'},
        {id: LecturePriorityEnum.NORMAL, nameEN: 'Normal', nameHE: 'רגילה'}
    ];

    public static statuses: any[] = [
        {id: LectureStatusEnum.ASSIGNED, nameEN: 'Assigned', nameHE: 'משויכת'},
        {id: LectureStatusEnum.COMPLETE, nameEN: 'Complete', nameHE: 'בוצעה'},
        {id: LectureStatusEnum.IRRELEVANT, nameEN: 'Irrelevant', nameHE: 'לא רלוונטית'},
        {id: LectureStatusEnum.PENDING, nameEN: 'Pending', nameHE: 'מחכה לאישור'},
        {id: LectureStatusEnum.SCHEDULED, nameEN: 'Scheduled', nameHE: 'נקבעה'},
        {id: LectureStatusEnum.UNASSIGNED, nameEN: 'UnAssigned', nameHE: 'פניה חדשה'},
    ];

    public static PAID_STATUS = {id: 'PAID', nameEN: 'Paid', nameHE: 'הרצאה בתשלום'};
    public static NOTES_EXTRA_PH = {id: 'NOTES_EXTRA_PH', nameEN: 'Volunteer Notes', nameHE: 'הערות מתנדב'};
    public static ORIG_LECTURER = {id: 'ORIG_LECTURER', nameEN: 'Original Lecturer', nameHE: 'מתנדב מקורי'};

}
